import { Link } from "react-router-dom";
import { KeyRound, BadgeDollarSign, Megaphone, TrendingUp, ArrowRight, Lock } from "lucide-react";

const PILLARS = [
  { icon: Lock, title: "We control access", desc: "Affiliates can't get in without us. Social Flats is the exclusive gateway to our vetted network — no middlemen, no gatekeeping fees." },
  { icon: BadgeDollarSign, title: "Free to join", desc: "Zero sign-up cost. Affiliates register through Social Flats in minutes and start earning immediately." },
  { icon: Megaphone, title: "Ready-made ads", desc: "Skip the design work. Get proven, plug-and-play ad creatives built to convert on every platform." },
  { icon: TrendingUp, title: "We grow your socials", desc: "Our team actively helps grow your social media presence — more followers means more clicks means more money." },
];

export const GatewaySection = () => (
  <section data-testid="gateway-section" className="max-w-7xl mx-auto px-4 sm:px-8 mt-24">
    <div className="relative bg-slate-900 rounded-2xl overflow-hidden">
      <div className="noise-overlay" />
      <div className="relative p-10 md:p-16">
        <p className="uppercase text-xs tracking-[0.2em] font-semibold text-emerald-400 mb-4 flex items-center gap-2">
          <KeyRound className="w-4 h-4" /> The Exclusive Gateway
        </p>
        <h2 className="font-heading text-3xl md:text-4xl tracking-tight text-white max-w-2xl mb-4">
          One door into the affiliate network. <span className="text-emerald-400">We hold the key.</span>
        </h2>
        <p className="text-slate-400 max-w-2xl leading-relaxed mb-10">
          Social Flats controls access to the affiliate network. Sign up free through us, grab ready-made ads, let us grow your social presence — and earn <span className="text-white font-semibold">15% per click value</span> from day one.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
          {PILLARS.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="bg-white/5 border border-white/10 rounded-lg p-6 backdrop-blur-sm">
              <Icon className="w-6 h-6 text-emerald-400 mb-3" />
              <p className="font-heading font-semibold text-white text-sm mb-2">{title}</p>
              <p className="text-xs text-slate-400 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link to="/signup" data-testid="gateway-join-cta"
            className="flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-emerald-600 text-white font-medium hover:bg-emerald-500 transition-colors duration-200">
            Join Free — Start Earning 15% <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/rewards" data-testid="gateway-rewards-cta"
            className="flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-white/25 text-white font-medium hover:bg-white/10 transition-colors duration-200">
            See Tiers & Bonuses
          </Link>
        </div>
      </div>
    </div>
  </section>
);
